export const supportedLocales = {
    en: "English",
    sp: "Español",
};

export const fallbackLocale = "en";